import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AppPermission } from '@app/shared/services/apps/apps.service';

@Component({
  selector: 'sbnb-alertify',
  template: `
    <sbnb-apps-detail-page
      vendorCode="alertify"
      name="Alertify"
      logoTile="/assets/images/apps/alertify-full.png"
      builtBy="Alertify"
      builtByLink="https://www.alertify.io/"
      [categories]="['Monitoring']"
      [permissions]="[
        AppPermission.propertyListingRead,
        AppPermission.reservationRead,
        AppPermission.financialsRead,
        AppPermission.calendarRead,
        AppPermission.messageWrite,
      ]"
      email="support@alertify.io"
      [beta]="false"
      [helpArticles]="[
        {
          id: '10476941',
          title: 'Connect Hospitable with Alertify to Monitor Noise Levels and Indoor Smoking'
        }
      ]">
      <ng-container description>
        <p>
          Connect Hospitable to your Alertify dashboard so you can view not only which Alertify devices are in which
          unit, but what guests are residing in your units at any given time. This way, you can cut the hassle and reach
          out to your guests as soon as you receive violations.
        </p>
        <strong>Integrate Hospitable with Alertify! Use Hospitable to...</strong>
        <ul class="list list__looser">
          <li>Map units from Hospitable to units in your Alertify dashboard</li>
          <li>See which guests were in the unit where a violation took place</li>
          <li>Ensure key guest information is included in Alertify’s after-incident reports</li>
          <li>Set up automatic notifications to your guests for the following events:</li>
          <ul class="list list__looser">
            <li>Noise levels are exceeded</li>
            <li>Smoking is detected</li>
          </ul>
        </ul>
      </ng-container>
      <sbnb-image-carousel
        [images]="[
          '/assets/images/apps/alertify/alertify-1.jpg',
          '/assets/images/apps/alertify/alertify-2.jpg',
          '/assets/images/apps/alertify/alertify-3.jpg',
          '/assets/images/apps/alertify/alertify-4.jpg',
          '/assets/images/apps/alertify/alertify-5.jpg',
          '/assets/images/apps/alertify/alertify-6.jpg',
          '/assets/images/apps/alertify/alertify-7.jpg'
        ]"></sbnb-image-carousel>
    </sbnb-apps-detail-page>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertifyComponent {
  public AppPermission = AppPermission;
  constructor() {}
}
